import { render } from "./VaBeneProgrammeAffiliationListPage.vue?vue&type=template&id=2e8b28f7&scoped=true&ts=true"
import script from "./VaBeneProgrammeAffiliationListPage.vue?vue&type=script&lang=ts"
export * from "./VaBeneProgrammeAffiliationListPage.vue?vue&type=script&lang=ts"

import "./VaBeneProgrammeAffiliationListPage.vue?vue&type=style&index=0&id=2e8b28f7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e8b28f7"]])

export default __exports__